module.exports = __webpack_public_path__ + "img/item-bottom.ab73b0b5.png";